/**
 * Computes the Euclidean distance between two 3D coordinates.
 * @param pos1 a 3D coordinate
 * @param pos2 a 3D coordinate
 */
 export function distBetween(pos1: Array<number>, pos2: Array<number>): number{
    let xDistSq: number = Math.pow((pos2[0]-pos1[0]), 2);
    let yDistSq: number = Math.pow((pos2[1]-pos1[1]), 2);
    let zDistSq: number = Math.pow((pos2[2]-pos1[2]), 2);

    return Math.sqrt(xDistSq + yDistSq + zDistSq);
}

/**
   * Stores the velocity of a projectile based on where a user clicks.
   * @param event: Mouse's event
   * @returns the new projectile's velocity
   */
 export const getProjectileVel = (
    event:MouseEvent
  ) => {
    let x: number = event.clientX - window.innerWidth / 2;
    let y: number = event.clientY - window.innerHeight / 2 - 32; // height of navbar is 64px (1/2 is 32)

    let xCoord = 0.65 * x;
    let yCoord;
    if (y < 0) {
      yCoord = -y;
    } else {
      yCoord = -0.25 * y;
    }

    let depth: number = 300;

    let xAngle = Math.atan2(xCoord - 0, depth);
    let yAngle = Math.atan2(yCoord - -1, depth);

    let vel = 1.2;
    let xVel = Math.sin(xAngle) * vel;
    let yVel = Math.sin(yAngle) * vel;
    let zVel = -Math.cos(xAngle) * vel;

    return [xVel, yVel, zVel]
  }